module.exports = __webpack_public_path__ + "static/media/general-de-seguros-headset.272e2255.svg";